import { Role } from '../../../../shared/enums/role.enum';
import { NavItemI } from '../../../../shared/interfaces/nav-item.interface';

export const SIDE_MENU_ITEMS: NavItemI[] = [
  {
    translationPath: 'sideMenu.home',
    activeIcon: 'svgs/side-menu/active-home.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-home.svg',
    route: ['', 'home'],
    alt: 'Home',
    roles: [Role.INSTRUCTOR, Role.DEAN, Role.PROGRAM_MANAGER, Role.COORDINATOR],
  },

  {
    translationPath: 'sideMenu.courseSectionsReview',
    activeIcon: 'svgs/side-menu/active-course-sections.svg',
    nonActiveIcon: 'svgs/side-menu/inactive-course-sections.svg',
    route: ['course-sections-reviews'],
    alt: 'C.Sections Review',
    roles: [Role.SUPER_ADMIN, Role.DEAN, Role.DEPARTMENT_MANAGER],
  },

  {
    translationPath: 'sideMenu.graduateAttributes',
    activeIcon: 'svgs/side-menu/active-graduate-attributes.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-graduate-attributes.svg',
    route: ['graduate-attributes'],
    alt: 'Graduate Attributes',
    roles: [Role.SUPER_ADMIN, Role.ADMIN],
  },

  {
    translationPath: 'sideMenu.nationalQualificationsFrameworkDescriptor',
    activeIcon:
      'svgs/side-menu/active-national-qualifications-framework-descriptors.svg',
    nonActiveIcon:
      'svgs/side-menu/non-active-national-qualifications-framework-descriptors.svg',
    route: ['national-qualifications-framework-descriptors'],
    alt: 'Graduate Attributes',
    roles: [Role.SUPER_ADMIN, Role.ADMIN],
  },

  {
    translationPath: 'sideMenu.progressReports',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: ['progress-reports'],
    alt: 'Progress Reports',
    roles: [Role.SUPER_ADMIN, Role.ADMIN],
  },

  {
    translationPath: 'entities.evaluationCriterion',
    activeIcon: 'svgs/side-menu/active-course-sections.svg',
    nonActiveIcon: 'svgs/side-menu/inactive-course-sections.svg',
    route: ['evaluation-criteria'],
    alt: 'Evaluation Criteria',
    roles: [Role.SUPER_ADMIN, Role.ADMIN],
  },

  {
    translationPath: 'sideMenu.programs',
    activeIcon: 'svgs/side-menu/active-program.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-program.svg',
    route: ['programs'],
    alt: 'Programs',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.PROGRAM_MANAGER,
      Role.DEPARTMENT_MANAGER,
    ],
  },

  {
    translationPath: 'sideMenu.courses',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: ['courses'],
    alt: 'Courses',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.PROGRAM_MANAGER,
      Role.COORDINATOR,
      Role.DEPARTMENT_MANAGER,
    ],
  },

  {
    translationPath: 'sideMenu.courseSections',
    activeIcon: 'svgs/side-menu/active-course-sections.svg',
    nonActiveIcon: 'svgs/side-menu/inactive-course-sections.svg',
    route: ['course-sections'],
    alt: 'Course Sections',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.PROGRAM_MANAGER,
      Role.COORDINATOR,
      Role.DEPARTMENT_MANAGER,
    ],
  },
];
